// import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { formatWithThousandsSeparator } from "../utils/currency.ts";
import GoBackHeader from "../components/GoBackHeader.tsx";

export default function Tickets() {
  const { state } = useLocation();
  const event  = state?.event || {};
  const navigate = useNavigate();

  return (
    <div
      style={{
        backgroundImage: `url('/pattern-14.png')`,
        backgroundSize: "inherit",
        backgroundPosition: "center",
        fontFamily: "Exo",
        backgroundRepeat: "no-repeat",
      }}
      className="min-h-screen flex flex-col"
    >
      <div className="absolute inset-0 overflow-y-auto z-10 px-4 py-4">
        {/* <Header /> */}
        <GoBackHeader />
        <div className="mt-14">
          <h2 className=" text-[#194E6E]  text-3xl text-center font-bold   my-8">
            {event?.title}
          </h2>
          <h2 className="text-2xl text-center font-semibold text-black my-8">
            Choix de mon ticket
          </h2>
          <div className="flex flex-col gap-4">
            {event?.services?.length > 0 &&
              event?.services?.map(
                (
                  service: {
                    amount: number;
                    name: string;
                    reference: string;
                    quantity: number;
                  },
                  index: number
                ) => (
                  <button
                    onClick={() => {
                      if (service?.quantity >= 1) {
                        navigate(
                          `/Ticket/${event?.reference}/${service?.reference}`,
                            {
                                state: {
                                    event,
                                    service
                                }
                            }
                        );
                      }
                    }}
                    key={index}
                    className={`${service?.quantity <= 0 ? "bg-gray-100" : "bg-primary"} ${service?.quantity <= 0 && "cursor-not-allowed"} rounded-lg flex min-h-14 items-center justify-between px-5 py-8`}
                  >
                    <div className="flex items-start flex-col gap-1">
                      <span
                        className={`text-xl font-bold text-start text-white  ${service?.quantity <= 0 ? "text-gray-300" : "text-white"}`}
                      >
                        {service?.name}
                      </span>
                      {service?.quantity <= 0 && (
                        <p className="text-gray-300">Non disponible</p>
                      )}
                      <p className="text-xs text-gray-200">
                        {service?.quantity} ticket{service?.quantity > 1 && "s"}{" "}
                        disponible{service?.quantity > 1 && "s"}
                      </p>
                    </div>

                    <span
                      className={`text-[#213A6E] text-end font-bold text-xl  ${service?.quantity <= 0 ? "text-gray-300" : "text-white"}`}
                    >
                      {service?.amount === 0
                        ? "Gratuit"
                        : formatWithThousandsSeparator(
                            service?.amount || 0
                          )}{" "}
                      {service?.amount !== 0 && "XOF"}
                    </span>
                  </button>
                )
              )}
          </div>
        </div>
      </div>
    </div>
  );
}
